import React from 'react';

const CrossIcon = (props: any) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.03027 4.02942L9.96997 9.96912" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.03014 9.96922L9.96983 4.02953" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CrossIcon;
